<template>
  <div>
    <Breadcrumb :style="{margin: '24px 0'}">
        <BreadcrumbItem>首页</BreadcrumbItem>
        <BreadcrumbItem>管理员管理</BreadcrumbItem>
        <BreadcrumbItem>添加管理员</BreadcrumbItem>
    </Breadcrumb>
    <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
      <div class="head_style">
        <h2>添加管理员</h2>
      </div>
      <div>
        <p ><b>账&nbsp;&nbsp;&nbsp;&nbsp;号</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="username"></Input>
      </div><br>
      <div>
        <p ><b>密&nbsp;&nbsp;&nbsp;&nbsp;码</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="password" type="password"></Input>
      </div><br>
      <div>
        <p ><b>确认密码</b></p>
        <Input  placeholder="请输入管理员账号" style="width: 300px" v-model="again_password" type="password"></Input>
      </div><br><br>
      <div class="button_style">
        <Button type="success" @click="adminUpdate()">提交</Button>
        <Button type="ghost" @click="adminReturn()">返回</Button>
      </div>
    </Content>
  </div>
</template>
<style scoped>
* {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
p {
  line-height: 30px;
}
.head_style {
  height: 50px;
}
</style>
<script>
import adminadd from '@/assets/js/views/admin/adminadd';

export default {
  ...adminadd,
};
</script>

